<template>
  <AdvancedScrollList :items="listItems" :loading="isFetching" class="mt-4">
    <template v-slot:item="{ item }">
      {{ item[$props.rlsGroup] || item[$props.rlsGroup.toLowerCase()] }}
    </template>
  </AdvancedScrollList>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api'
import { createVuexHelpers } from 'vue2-helpers'

import { useRLSGroup } from '@composables'

import { AdvancedScrollList } from '@components/advanced'

export default defineComponent({
  name: 'CompanyRLSList',
  components: {
    AdvancedScrollList
  },
  props: {
    rlsGroup: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const { useGetters } = createVuexHelpers()

    const { company } = useGetters(['company'])

    const { isFetching, rlsGroupItems, fetchRLSGroupItems } = useRLSGroup(
      props.rlsGroup
    )

    const listItems = computed(() => {
      if (!!company.value) {

        const groupKey = props.rlsGroup.toLowerCase();
        const companyGroupFieldIds = company.value[`rls_${groupKey}_ids`] || []

        return rlsGroupItems.value.filter((rlsGroupItem) => {
          return companyGroupFieldIds.includes(rlsGroupItem.id)
        })
      } else {
        return []
      }
    })

    return {
      isFetching,
      rlsGroupItems,
      fetchRLSGroupItems,

      listItems
    }
  }
})
</script>

<style scoped>
div >>> .list-group {
  max-height: 420px;
  padding: 0 12px;
}

div >>> .list-group > .list-group-item {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}
</style>
